<template>
     <div class="container" v-title="'队伍报名'">
         <Navigation-bar v-scrollShadow="isTabShadow ? 0 : roll">
            <template #title>
				<div class="nav-title_pulldown" v-show="isTabShadow" @click="openPopup('deputation')">
					<span>{{deputationName}}</span>
                    <YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
				</div>
            </template>
         </Navigation-bar>
         <div class="container_content" v-show="pageShow">
             <div id="TeamPersonnel" v-scroll="roll">
                <Title subtitle="点击下箭头，可切换/新增/修改代表队">
					<template #title>
						<div class="page-title_pulldown" @click="openPopup('deputation')">
							<span>{{deputationName}}</span>
                            <YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
						</div>
					</template>
                </Title>
                <template v-if="!isSubmitEnroll">
                    <div id="category" :style="isTabShadow ? {'height':categoryH+'px'} : ''" v-show="!(categoryTebIndex == 0 && loadMore == '无数据')">
                        <div class="category_fixed" ref="category_fixed" :class="{'fixed': isTabShadow}" v-scrollShadow="isTabShadow && roll - titleHeight">
                            <div class="category_tab">
                                <ul>
                                    <li :class="{'active':categoryTebIndex == 0}" @click="setTab(0)">全部</li>
                                    <li :class="{'active':categoryTebIndex == 2}">
                                        <div class="SelectGroup_text" :class="{'active': group.Id > 0}" @click="selectShow = true">
                                            <span>运动员</span>
                                            <YD-image v-if="group.Id == 0" :src="selectShow ? 'icon/icon_下拉箭头_灰色_向上' : 'icon/icon_下拉箭头_灰色_向下'"></YD-image>
                                            <YD-image v-else :src="selectShow ? 'icon/icon_下拉箭头_白色_向上' : 'icon/icon_下拉箭头_白色_向下'"></YD-image>
                                        </div>
                                    </li>
                                    <li :class="{'active':categoryTebIndex == 1}" @click="setTab(1)">其他人员</li>
                                </ul>
                                <div class="doubles" :class="{'select': doublesSelect}" v-if="group.type == 3">
                                    <div @click="openDoublesSelect">
                                        <YD-image :src="doublesSelect ? 'icon/icon_管理组合_选中' : 'icon/icon_管理组合'"></YD-image>
                                        <span>队员组合</span>
                                    </div>
                                    <div class="hint" v-if="isHint" @click.stop>
                                        <span>点击此处为队员分配组合</span>
                                        <YD-image src="icon/icon_组合_关闭" @click.native.stop="closeHint"></YD-image>
                                    </div>
                                </div>
                            </div>
                            <div class="category_info">
                                <template v-if="group.type == 3">
                                    <div class="info" v-if="!doublesSelect"><span>{{categoryInfo.groupName}}共<i>{{categoryInfo.num}}</i>对组合</span></div>
                                    <div class="info" v-else><span>{{categoryInfo.groupName}}共<i>{{member.list.length + noDoublesUser.list.length}}</i>名</span></div>
                                </template>
                                <div class="info" v-else><span>{{categoryInfo.groupName}}共<i>{{categoryInfo.num}}</i>名</span></div>
                                <div class="hint" v-show="categoryInfo.hints.length > 0 && !doublesSelect">
                                    <ul>
                                        <li v-for="(item,index) in categoryInfo.hints" :key="index"><div>{{item}}</div></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="load_more" :style="loadMore == '无数据'?'padding-top:0.5rem':''" v-show="rests.list.length == 0 && loadMore">
                        <img src="@images/no_data/暂无队员@2x.png" v-show="loadMore == '无数据'">
                        <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                    </div>
                    <div id="member_list">
                        <ul>
                            <li v-for="(item,index) in memberList" :key="index" 
                                @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,1)" 
                                :class="[item.doublesClassName,{ 'select': doublesSelect }]"
                            >
                                <div class="member_content">
                                    <div class="member_img">
                                        <img :src="getUserPhoto(item.UserInfo)">
                                    </div>
                                    <div class="member_info">
                                        <div class="member_name">
                                            <span>{{item.UserInfo.Name}}</span>
                                            <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length">
                                                <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                    <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                    <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="member_group">
                                            <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length">
                                                <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                    <span :key="'a'+groupIndex">{{groupItem.GroupInfo.Name}}</span>
                                                    <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                                </template>
                                            </template>
                                            <span v-else>暂无组别</span>
                                        </div>
                                    </div>
                                    <template v-if="!doublesSelect">
                                        <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,1)"></YD-image>
                                    </template>
                                    <template v-else>
                                        <div class="doubles_select"></div>
                                    </template>
                                    <template v-if="item.doublesNumText">
                                        <div class="doubles_sign">{{item.doublesNumText}}</div>
                                    </template>
                                </div>
                            </li>
                        </ul>
                        <template v-if="group.type == 3">
                            <div v-show="noDoublesUser.list.length && !doublesSelect">下列队员尚未分配组合</div>
                            <ul v-show="noDoublesUser.list.length">
                                <li v-for="(item,index) in noDoublesUserList" :key="index" 
                                    @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,3)"  
                                    :class="doublesSelect ? [item.doublesClassName, 'select'] : ''"
                                >
                                    <div class="member_content">
                                        <div class="member_img">
                                            <img :src="getUserPhoto(item.UserInfo)">
                                        </div>
                                        <div class="member_info">
                                            <div class="member_name">
                                                <span>{{item.UserInfo.Name}}</span>
                                                <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length">
                                                    <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                        <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                        <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                                    </template>
                                                </template>
                                            </div>
                                            <div class="member_group">
                                                <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length">
                                                    <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                        <span :key="'a'+groupIndex">{{groupItem.GroupInfo.Name}}</span>
                                                        <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                                    </template>
                                                </template>
                                                <span v-else>暂无组别</span>
                                            </div>
                                        </div>
                                        <template v-if="!doublesSelect">
                                            <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,3)"></YD-image> 
                                        </template>
                                        <template v-else>
                                            <div class="doubles_select"></div>
                                        </template>
                                        <template v-if="item.doublesNumText">
                                            <div class="doubles_sign">{{item.doublesNumText}}</div>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </template>
                        <div v-show="rests.list.length">可加入该组的备选参赛人员</div>
                        <ul v-show="rests.list.length">
                            <li v-for="(item,index) in restsList" :key="index" 
                                @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,2)" 
                                :class="doublesSelect ? [item.doublesClassName, 'select'] : ''"
                            >
                                <div class="member_content">
                                    <div class="member_img">
                                        <img :src="getUserPhoto(item.UserInfo)">
                                    </div>
                                    <div class="member_info">
                                        <div class="member_name">
                                            <span>{{item.UserInfo.Name}}</span>
                                            <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length">
                                                <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                    <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                    <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="member_group">
                                            <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length">
                                                <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                    <span :key="'a'+groupIndex">{{groupItem.GroupInfo.Name}}</span>
                                                    <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                                </template>
                                            </template>
                                            <span v-else>暂无组别</span>
                                        </div>
                                    </div>
                                    <template v-if="!doublesSelect">
                                        <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,2)"></YD-image> 
                                    </template>
                                    <template v-else>
                                        <div class="doubles_select"></div>
                                    </template>
                                    <template v-if="item.doublesNumText">
                                        <div class="doubles_sign">{{item.doublesNumText}}</div>
                                    </template>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
                <div class="enroll_operation" v-else>
                    <div>
                        <div class="registered">
                            <div>
                                <h4>代表队已报名</h4>
                                <p>请前往报名记录页面查看</p>
                            </div>
                            <button v-href="`/Enroll/TeamAuditDetail?deputationEnrollId=${deputationEnrollId}&subLeagueId=${subLeagueId}`">前往</button>
                            <img src="~@images/enroll/代表队已报名.png">
                        </div>
                        <div class="pay" v-if="isNoPay">
                            <div>
                                <h4>未支付服务费</h4>
                                <p>请前往报名记录页面查看</p>
                            </div>
                            <button @click="showPay()">去支付</button>
                            <img src="~@images/enroll/未支付报名费.png">
                        </div>
                    </div>
                </div>
             </div>
         </div>
         <div class="bottom_operation" v-if="!isSubmitEnroll" v-show="pageShow && !doublesSelect">
             <button v-href="`/Enroll/AddMember?deputationEnrollId=${deputationEnrollId}&subLeagueId=${subLeagueId}&eventsId=${eventsId}`">新增队员</button>
             <button @click="goSubmit()">去提交</button>
         </div>
         <div class="doubles_operation" v-show="doublesSelect">
             <button @click="openDoublesSelect">取消</button>
             <button @click="submitDoubles">确定</button>
         </div>
         <SelectGroup 
            :show.sync="selectShow"
            :groups="group.list"
            :groupId="group.Id" 
            @change="group.Id = $event"
        ></SelectGroup>
         <MemberInfo 
            :show.sync="memberInfo.show" 
            :subLeagueId="subLeagueId"
            :deputationEnrollId="deputationEnrollId"
            :member-info="memberInfo.info"
            :oss-options="UploadOptions"
            @save-success="saveMemberInfo"
        ></MemberInfo>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="btnCallback"></Alert-tip>
		<Popup type="bottom" ref="deputation" title="选择当前代表队" showClose :maskClick="false" align="center">
			<div class="deputation">
				<div class="deputation_list">
					<div class="deputation_item" :class="{
						'active': item.DeputationId == deputationId
					}" v-for="item,index in deputationList" @click="selectDeputation(item)">
						<span>{{item.DeputationName}}</span>
					</div>
				</div>
				<div class="operation">
					<div class="deputation_operation">
						<div class="button" @click="addDeputation()">
                            <YD-image src="icon/add_deputation"></YD-image> 
							<span>新增代表队</span>
						</div>
						<div class="button" @click="editDeputation()">
                            <YD-image src="icon/edit_deputation"></YD-image> 
							<span>修改代表队</span>
						</div>
					</div>
                    <div class="button" @click="closePopup('deputation')">取消</div>
				</div>
			</div>
		</Popup>
     </div>
</template>
<script>
import SelectGroup from './components/SelectGroup.vue';
import MemberInfo from './components/MemberInfo.vue';
import Popup from '../../components/Popup.vue';
import {
    convertSize,
    numberToChinese
} from '@js';
import {
    GetMyLastOperateEnrollDeputation,//获取最后操作的报名代表队
    GetMyEnrollDeputationList,//获取报名的代表队
    GetMyEnrollDeputationUserList,//获取代表队人员
    GetMyEnrollDeputationGroupUserList,//获取代表队分组人员
    GetCanJoinGroupUserList,//获取分组可以加入的人员
    GetMyEnrollDeputationGroupList,//获取代表队可报名组别
    GetUserEnrollAllRoleList,//获取所有身份
    DeleteDeputationEnrollUser,//删除参赛人员
    GetAppOwnerDeputationEnrollUploadOptions,
    CheckDeputationEnrollHaveAthleteNoGroup, //检查运动员是否选择分组
    SaveDeputationEnrollDoubles, //保存组合
    GetUserEnrollPayStatusInfo, //查询支付状态
    CreateDeputationLeagueEnrollOrder //创建订单
} from '@/api';
import appInteraction from '@/common/appInteraction.js';
import communicate from '@/common/communicate.js';
import tools from '@/common/tools.js';

export default {
    name:"TeamPersonnel",
    components:{
        SelectGroup,
        MemberInfo,
        Popup
    },
    data(){
        var subLeagueId = parseInt(this.$route.query.subLeagueId);
        return{
            subLeagueId: isNaN(subLeagueId) ? 0 : subLeagueId,
            pageShow: false,
            roll:0,
            categoryH:0,
			deputationList: [],
			deputationId: 0,
			isSubmitEnroll: false,
            categoryTebIndex:0,
            categoryInfo:{
                groupName: "",
                num: 0,
                hints: []
            },
            isHint:false,
            doublesSelect: false,
            doublesArr:[],
            selectDoublesArr:[],
            doublesIndex:-1,
            roles:[],
            group:{
                list: [],
                Id: 0,
                type: 0,
                GenderLimit: 0
            },
            selectShow: false,
            member:{
                list:[],
                deleteIndex: -1
            },
            rests:{
                list:[],
                deleteIndex: -1
            },
            noDoublesUser:{
                list:[],
                deleteIndex: -1
            },
            optionType: 1,
            memberInfo:{
                show:false,
                info: {},
                updateIndex: 0
            },
            loadMore:"",
            alertTip:{},
            tipShow:false,
            UploadOptions:{},
            auditOption:{
                type: 0,//1无组别用户 2其他人员修改 3组别人员修改
                id: 0,//type=1 用户Id, type=3 分组Id
            },
            isNoPay: false
        }
    },
    created(){
        let deputationId = +this.$route.query.deputationId || 0;
        this.getDeputationList(deputationId);
        if(!localStorage.getItem('doubles_select_hint')){
            this.isHint = true;
        }
		//报名费支付状态
		communicate.enrollPayStatus.$on(()=>{
			GetUserEnrollPayStatusInfo({
				DptEnrollId: this.deputationEnrollId
			}).then(data => {
				if(data.Code == 0){
					this.isNoPay = data.IsNotPaid;
				}
			})
		});
        communicate.paySuccess.$on(()=>{
            this.isNoPay = false;
        })
    },
    activated(){
        this.roll -= 0.001;
        //添加队员成功
        if(sessionStorage.getItem('addMember')){
            sessionStorage.removeItem('addMember');
            this.saveMemberInfo();
        }
        //添加代表队成功
        if(sessionStorage.getItem('addTeam')){
            sessionStorage.removeItem('addTeam');
            this.getDeputationList(0);
        }
        //修改代表队成功
        if(sessionStorage.getItem('editDeputation')){
            sessionStorage.removeItem('editDeputation');
            this.getDeputationList(this.deputationEnrollId);
        }
        //修改用户手机号成功
        if(sessionStorage.getItem('updatePhone')){
            let list = [],
                index = this.memberInfo.updateIndex;
            if(this.optionType == 1){
                list = this.member.list;
            }else if(this.optionType == 2){
                list = this.rests.list;
            }else if(this.optionType == 3){
                list = this.noDoublesUser.list;
            }
            if(index > -1){
                list[index].UserInfo.Phone = sessionStorage.getItem('updatePhone');
                if(this.optionType == 1){
                    this.$set(this.member,'list',list);
                }else if(this.optionType == 2){
                    this.$set(this.rests,'list',list);
                }else if(this.optionType == 3){
                    this.$set(this.noDoublesUser,'list',list);
                }
            }
            sessionStorage.removeItem('updatePhone');
        }
        //提交审核成功
        if(sessionStorage.getItem('auditSuccess')){
            this.isSubmitEnroll = true;
            sessionStorage.removeItem('auditSuccess');
        }
        //未提交审核 删除组别后返回
        if(sessionStorage.getItem('deleteGroup')){
            let groupId = parseInt(sessionStorage.getItem('deleteGroup'));
            this.getGroupList();
            if(this.categoryTebIndex == 2 && this.group.Id == groupId){
                this.$set(this.rests,'list',[]);
                this.getGroupUserList(groupId);
            }
            sessionStorage.removeItem('deleteGroup');
        }
        //修改操作
        if(sessionStorage.getItem('auditOption')){
            let auditOption = JSON.parse(sessionStorage.getItem('auditOption'));
            this.auditOption = auditOption;
            if(auditOption.type == 2){
                this.setTab(1);
            }else if(auditOption.type == 3){
                this.group.Id = auditOption.id;
            }else{
                this.setTab(0);
            }
            sessionStorage.removeItem('auditOption');
        }
    },
    destroyed(){
        communicate.enrollPayStatus.$off();
        communicate.paySuccess.$off();
    },
    computed:{
        titleHeight(){
            return convertSize(1.88);
        },
        isTabShadow(){
            return this.roll >= this.titleHeight;
        },
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
		deputationInfo(){
			return this.deputationList.find(item=>item.DeputationId == this.deputationId);
		},
		deputationEnrollId(){
			if(this.deputationInfo){
				return this.deputationInfo.DeputationEnrollId;
			}
			return 0;
		},
		deputationName(){
			if(this.deputationInfo){
				return this.deputationInfo.DeputationName;
			}
			return '';
		},
		eventsId(){
			if(this.deputationInfo){
				return this.deputationInfo.EventsId;
			}
			return 0;
		},
		memberList(){
			let list = [];
			let userList = this.member.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		},
		restsList(){
			let list = [];
			let userList = this.rests.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		},
		noDoublesUserList(){
			let list = [];
			let userList = this.noDoublesUser.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		}
    },
    watch:{
        '$route'(to,from){
            if(to.name == "TeamPersonnel" && from.name == "AddTeam" && !sessionStorage.getItem('addTeam') && this.deputationList.length == 0){
                this.$navigation.back();
            }
        },
        roll(newVal){
            if(newVal >= this.titleHeight){
                var categoryH = this.$refs['category_fixed'].offsetHeight;
                this.categoryH = categoryH;
            }else{
                this.categoryH = 0;
            }
        },
        deputationEnrollId(newVal){
            if(newVal > 0){
                GetAppOwnerDeputationEnrollUploadOptions({
                    DeputationEnrollId: newVal
                }).then(data=>{
                    if(data.Code == 0){
                        this.UploadOptions = data.UploadOptions;
                    }
                })
				this.isSubmitEnroll = !!this.deputationInfo.FirstSubmitTime;
				this.isNoPay = this.deputationInfo.IsNotPaid;
				if (!this.isSubmitEnroll) {
					this.categoryTebIndex = 0;
					this.group.Id = 0;
					this.saveMemberInfo();
				}
            }
        },
        'group.Id':{
            deep:true,
            handler(newVal){
                if(newVal > 0){
                    this.categoryTebIndex = 2;
                    this.$set(this.rests,'list',[]);
                    this.doublesSelect = false;
                    this.setGroupInfo(newVal);
                    this.getGroupUserList(newVal);
                }
            }
        },
        'categoryInfo.hints':{
            deep:true,
            handler(){
                if(this.categoryH > 0){
                    var categoryH = this.$refs['category_fixed'].offsetHeight;
                    this.categoryH = categoryH;
                }
            }
        },
        'doublesSelect':{
            handler(newVal){
                this.$nextTick(function(){
                    if(this.categoryH > 0){
                        var categoryH = this.$refs['category_fixed'].offsetHeight;
                        this.categoryH = categoryH;
                    }
                })
            }
        }
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
        openPopup(ref){
			this.$refs[ref].open();
		},
		closePopup(ref){
			this.$refs[ref].close();
		},
		addDeputation(){
			this.$navigation.go('/Enroll/AddTeam?subLeagueId=' + this.subLeagueId);
			this.closePopup('deputation');
		},
		editDeputation(){
			this.$navigation.go(`/Enroll/AddTeam?subLeagueId=${this.subLeagueId}&deputationEnrollId=${this.deputationEnrollId}`);
			this.closePopup('deputation');
		},
		selectDeputation(item){
			this.deputationId = item.DeputationId;
			this.closePopup('deputation');
		},
        setTab(index){
            if(index != this.categoryTebIndex){
                this.categoryTebIndex = index;
                this.group.Id = 0;
                this.categoryInfo = {
                    groupName: "",
                    num: 0,
                    hints:[]
                };
                this.$set(this.rests,'list',[]);
                this.doublesSelect = false;
                this.group.type = 0;
                let type = index == 0 ? 0 : 2;
                this.getUserList(type);
            }else if(index == 0){
				this.infoLookInfo(this.member.list);
			}
        },
        //删除队员
        deleteMember(index,type){
            this.optionType = type;
            if(type == 1){
                this.member.deleteIndex = index;
            }else if(type == 2){
                this.rests.deleteIndex = index;
            }else if(type == 3){
                this.noDoublesUser.deleteIndex = index;
            }
            this.alertTip = {
                title:"温馨提示",
                text:"将删除您已添加的参赛人员，请确认操作",
                btnArr:["取消",{
                    text:"删除",
                    style:"color:#7AD21A"
                }]
            },
            this.tipShow = true;
        },
        //查看队员信息
        lookInfo(index,obj,type){
            var info = JSON.parse(JSON.stringify(obj));
            this.optionType = type;
            this.memberInfo.show = true;
            this.memberInfo.info = info.UserInfo;
            this.memberInfo.updateIndex = index;
        },
        btnCallback(text){
            this.tipShow = false;
            if(text == '删除'){
                var memberObj = {},
                    GroupId = 0;
                if(this.optionType == 1){
                    memberObj = this.member;
                    GroupId = this.group.Id;
                } else if(this.optionType == 2){
                    memberObj = this.rests;
                } else if(this.optionType == 3){
                    memberObj = this.noDoublesUser;
                    GroupId = this.group.Id;
                }
                let deleteIndex = memberObj.deleteIndex,
                    list = JSON.parse(JSON.stringify(memberObj.list)),
                    obj = list[deleteIndex];
                this.$Toast('正在删除','loading');
                DeleteDeputationEnrollUser({
                    DeputationEnrollId: this.deputationEnrollId,
                    UserEnrollId: obj.UserInfo.UserEnrollId,
                    GroupId
                }).then(data=>{
                    this.$Toast('hideLoading');
                    if(data.Code == 0){
                        this.$Toast('删除成功','success');
                        this.saveMemberInfo();
                    }
                }).catch(()=>{
                    this.$Toast('hideLoading');
                })
            }else if(text == "继续" || text == "忽略"){
                this.$navigation.go(`/Enroll/TeamAuditDetail?deputationEnrollId=${this.deputationEnrollId}&subLeagueId=${this.subLeagueId}&audit=1`)
            }else if(text == "去操作"){
                if (this.auditOption.type == 3) { //切换到未组合的双人组别
                    let groupId = this.auditOption.id;
                    if (this.group.Id == groupId) {
                        this.group.Id == 0;
                    }
                    this.group.Id = groupId;
                } else if (this.auditOption.type == 1) { //打开没有分配组别的运动员对话框
                    if (this.categoryTebIndex == 0) {
                        this.categoryTebIndex = 3;
                    }
                    this.setTab(0);
                }
            }
        },
        //管理组合
        openDoublesSelect(){
            if(!this.doublesSelect){
                this.selectDoublesArr = JSON.parse(JSON.stringify(this.doublesArr));
                this.doublesIndex = -1;
            }
            if(this.isHint){
                localStorage.setItem('doubles_select_hint',1);
                this.isHint = false;
            }
            this.doublesSelect = !this.doublesSelect;
        },
        closeHint(){
            localStorage.setItem('doubles_select_hint',1);
            this.isHint = false;
        },
        //组合选择
        doublesAddUser({UserEnrollId, Gender}, doublesClassName, doublesNum){
            var arr = JSON.parse(JSON.stringify(this.selectDoublesArr));
            if(doublesClassName == "no-select"){
                let index = this.doublesIndex,
                    GenderLimit = this.group.GenderLimit;
                if(index == -1){
                    arr.push([{
                        id: UserEnrollId,
                        sex: Gender
                    }])
                    this.doublesIndex = arr.length - 1;
                    this.$set(this, 'selectDoublesArr', arr);
                }else{
                    let doublesUsers = arr[index];
                    if(GenderLimit == 4 && doublesUsers[0].sex && Gender && doublesUsers[0].sex == Gender){
                        if(Gender == 1){
                            this.$Toast('请选择一名女队员');
                        }else{
                            this.$Toast('请选择一名男队员');
                        }
                    }else{
                        doublesUsers.push({
                            id: UserEnrollId,
                            sex: Gender
                        })
                        arr[index] = doublesUsers;
                        let doublesIndex = -1;
                        for(var i=0;i<arr.length;i++){
                            if(arr[i].length == 1){
                                doublesIndex = i;
                                break;
                            }
                        }
                        this.doublesIndex = doublesIndex;
                        this.$set(this, 'selectDoublesArr', arr);
                    }
                }
            }else{
                let index = doublesNum - 1;
                let doublesUsers = arr[index];
                if(doublesUsers.length == 1){
                    arr.splice(index,1);
                }else{
                    if(doublesUsers[0].id == UserEnrollId){
                        doublesUsers.splice(0,1);
                    }else if(doublesUsers[1].id == UserEnrollId){
                        doublesUsers.splice(1,1);
                    }
                    arr[index] = doublesUsers;
                }
                this.$set(this, 'selectDoublesArr', arr);
                if(arr.length == 0){
                    this.doublesIndex = -1;
                }else{
                    let doublesIndex = -1;
                    for(var i=0;i<arr.length;i++){
                        if(arr[i].length == 1){
                            doublesIndex = i;
                            break;
                        }
                    }
                    this.doublesIndex = doublesIndex;
                }
            }
        },
        //提交组合
        submitDoubles(){
            var selectDoublesArr = this.selectDoublesArr,
				groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == this.group.Id)[0];
            if(this.doublesIndex != -1){
                this.$Toast('请再选择一名队员');
            }else if(selectDoublesArr.length == 0){
                this.$Toast('请选择队员');
            }else if(groupObj.GroupSetting.AthletesMax && groupObj.GroupSetting.AthletesMax < selectDoublesArr.length){
                this.$Toast(`该组别限报${groupObj.GroupSetting.AthletesMax}对`,'error');
            }else{
                let arr = [];
                for(var i=0;i<selectDoublesArr.length;i++){
                    let users = selectDoublesArr[i];
                    arr.push({
                        "UserEnrollId1": users[0].id,
                        "UserEnrollId2": users[1].id,
                        "PairIndex": i + 1
                    })
                }
                this.$Toast('保存中','loading');
                SaveDeputationEnrollDoubles({
                    "DeputationEnrollId": this.deputationEnrollId,
                    "LeagueGroupId": this.group.Id,
                    "DoublesInfo": arr
                }).then(data=>{
                    this.$Toast('hideLoading');
                    if(data.Code == 0){
                        this.$Toast('保存成功','success');
                        this.doublesSelect = false;
                        this.categoryInfo = {
                            groupName: "",
                            num: 0,
                            hints:[]
                        };
                        this.getGroupList();
                        this.getGroupUserList(this.group.Id);
                    }
                }).catch(()=>{
                    this.$Toast('hideLoading');
                })
            }
        },
        //去提交
        goSubmit(){
            CheckDeputationEnrollHaveAthleteNoGroup({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0 ){
                    if (data.IsDoublesNoPair && data.NoPairGroups) {
                        this.auditOption = {type:3, id:data.NoPairGroups[0].GroupId};
                        let groupName = data.NoPairGroups.length > 1 ?
                                        `“${data.NoPairGroups[0].GroupName}”等${data.NoPairGroups.length}个组别`:
                                        `组别“${data.NoPairGroups[0].GroupName}”`;
                        this.alertTip = {
                            title:"温馨提示",
                            text:`${groupName}尚未进行队员组合操作，现在去操作？`,
                            btnArr:["忽略",{text:"去操作",style:"color:#7AD21A"}]
                        },
                        this.tipShow = true;
                    } else if (data.IsHave && data.NoGroupUsers) {
                        this.auditOption = {type:1, id:data.NoGroupUsers[0].UserId};
                        let userName = data.NoGroupUsers.length > 1 ? 
                                        `“${data.NoGroupUsers[0].Name}”等${data.NoGroupUsers.length}个队员` :
                                        `队员“${data.NoGroupUsers[0].Name}”`;
                        this.alertTip = {
                            title:"温馨提示",
                            text:`${userName}尚未分配组别，现在去分配？`,
                            btnArr:["忽略",{text:"去操作",style:"color:#7AD21A"}]
                        },
                        this.tipShow = true;
                    }else{
                        this.$navigation.go(`/Enroll/TeamAuditDetail?deputationEnrollId=${this.deputationEnrollId}&subLeagueId=${this.subLeagueId}&audit=1`)
                    }
                }
            })
        },
        //去支付
		showPay(isConfirm){
			GetUserEnrollPayStatusInfo({
				DptEnrollId: this.deputationEnrollId
			}).then(data => {
				if(data.Code == 0){
                    if(isConfirm){
                        if(data.IsNotPaid){
                            this.$Prompt({
                                title: '温馨提示',
                                message: '未查询到支付成功',
                                confirmText: '知道了'
                            })
                        }else{
                            this.isNoPay = false;
                            communicate.paySuccess.$emit();
                        }
                    }else{
                        if(data.IsNotPaid){
                            this.$Prompt({
                                title: "支付提示",
                                message: `
                                    <p>你需支付 <span style="color: #7AD21A">${data.TotalFee}元</span> 赛事服务费(${data.Price})锁定参赛资格。</p>
                                    <p style="text-align: center;color: #ff5630">*请您务必确认最终报名人数，如有人数变更系统将重新计算赛事服务费，已缴纳的费用将于 <span style="font-size: 1.2em;color: red">10</span> 个工作日内退回</p>`,
                                showCancel: true,
                                cancelText: "暂不",
                                confirmText: "去支付"
                            }).then(confirm=>{
                                if(confirm){
                                    this.go2Pay();
                                }
                            })
                        }else{
                            this.$Prompt({
                                title: '温馨提示',
                                message: '您已支付',
                                confirmText: '知道了'
                            })
                            this.isNoPay = false;
                        }
                    }
				}
			})
		},
		go2Pay(){
			CreateDeputationLeagueEnrollOrder({
				DptEnrollId: this.deputationEnrollId
			}).then(data => {
				if(data.Code == 0){
                    if(tools.isVersion('23061600')){
                        this.$navigation.go(`/Pay/EnrollCashier?money=${data.FeeTotal}&type=1&id=${data.LeagueEnrollOrderId}`);
                    }else{
                        let title,
                            message;
                        if(tools.isVersion('23060800')){
                            title = "支付提示";
                            message = `您是否已在微信小程序中完成支付?`;
                            appInteraction.jumpWxMiniApp(`/pages/pay/enrollCashier/enrollCashier?money=${data.FeeTotal}&type=101&id=${data.LeagueEnrollOrderId}`);
                        }else{
                            title = "去小程序支付";
                            message = `烦请您进入微信「亿动体育」小程序完成支付。<br/>
                                打开微信 >> 点击搜索 >> 选择小程序 >> 查找「亿动体育」>> 进入小程序`;
                        }
                        this.$Prompt({
                            title,
                            message,
                            showCancel: true,
                            cancelText: "未支付",
                            confirmText: "已支付"
                        }).then(confirm=>{
                            if(confirm){
                                this.showPay(true);
                            }
                        })
                    }
				}
			})
		},
        //获取代表队
        getDeputationList(deputationEnrollId){
            this.$Toast('正在获取参赛数据','loading');
            GetMyEnrollDeputationList({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                this.$Toast('hideLoading');
                if(data.Code == 0){
                    this.pageShow = true;
                    if(!data.EnrollDeputationList || data.EnrollDeputationList.length == 0){
                        this.$navigation.go('/Enroll/AddTeam?subLeagueId='+this.subLeagueId);
                    }else{
                        this.deputationList = data.EnrollDeputationList;
                        if(deputationEnrollId){
                            let deputationId = (data.EnrollDeputationList.filter(item=>item.DeputationEnrollId == deputationEnrollId)[0] || {}).DeputationId;
                            if(deputationId){
                                this.deputationId = deputationId;
                            }else{
                                this.deputationId = data.EnrollDeputationList[0].DeputationId;
                            }
                        }
                    }
                }
            }).catch(()=>{
                this.$Toast('hideLoading');
            })
            if(deputationEnrollId) return;
            GetMyLastOperateEnrollDeputation({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                this.$Toast('hideLoading');
                if(data.Code == 0){
                    this.pageShow = true;
                    if(data.EnrollDeputation){
                        this.deputationId = data.EnrollDeputation.DeputationId;
                    }
                }
            }).catch(()=>{
                this.$Toast('hideLoading');
            })
        },
        //获取已经报名的组别
        getGroupList(){
            if(!this.deputationEnrollId) return;
            GetMyEnrollDeputationGroupList({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    this.group.list = data.GroupList || [];
                    if(this.group.Id > 0){
                        this.setGroupInfo(this.group.Id);
                    }
                }
            })
        },
        //获取身份
        getRoleList(){
            if(!this.deputationEnrollId) return;
            GetUserEnrollAllRoleList({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    this.roles = data.RoleList;
                    this.setRoleInfo();
                }
            })
        },
        //按类型获取参赛人员
        getUserList(type){
            if(!this.deputationEnrollId) return;
            this.loadMore = "";
            GetMyEnrollDeputationUserList({
                DeputationEnrollId: this.deputationEnrollId,
                EnrollUserType: type
            }).then(data=>{
                if(data.Code == 0){
                    var EnrollUserList = data.EnrollUserList || [],
                        list = [];
                    //处理与查询分组的数据结构相同
                    EnrollUserList.forEach(item => {
                        list.push({
                            UserInfo: item
                        })
                    });
                    this.member.list = list;
                    this.categoryInfo.num = list.length;
                    this.setRoleInfo();
                    if(list.length == 0){
                        this.loadMore = "无数据";
                    } else if(type == 0){
						this.infoLookInfo(list);
					}
                }
            })
        },
		//审核页面点击分配组别触发
		infoLookInfo(list){
			if (!(this.auditOption.type == 1 && this.auditOption.id)) return;
			let memberInfo = {},
				index = -1;
			for (var i = 0; i < list.length; i++) {
				if (list[i].UserInfo.UserId == this.auditOption.id) {
					memberInfo = list[i];
					index = i;
					break;
				}
			}
			if (index > -1) {
				this.lookInfo(index, memberInfo, 1);
			}
			this.auditOption.id = 0;
		},
        //按照组别获取参赛人员
        getGroupUserList(groupId){
            this.loadMore = "";
            let groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == groupId)[0];
            GetMyEnrollDeputationGroupUserList({
                DeputationEnrollId: this.deputationEnrollId,
                GroupId: groupId
            }).then(data=>{
                if(data.Code == 0){
                    let GroupUserList = data.GroupUserList || [],
                        GroupDoublesUserList = data.GroupDoublesUserList || [];
                    if(groupObj.GroupSetting.GroupType == 3){
                        this.member.list =  GroupDoublesUserList;
                        this.noDoublesUser.list = GroupUserList;
                        if((!GroupUserList || GroupUserList.length == 0) && (!GroupDoublesUserList || GroupDoublesUserList.length == 0)){
                            this.loadMore = "无数据";
                        }
                        if(!GroupDoublesUserList || GroupDoublesUserList.length == 0){
                            this.doublesArr = [];
                        }else{
                            let doublesObj = {},
                                doublesArr = [];
                            for(var i=0;i<GroupDoublesUserList.length;i++){
                                let {UserInfo} = GroupDoublesUserList[i];
                                let arr = doublesObj[UserInfo.PairId] || [];
                                arr.push({
                                    id: UserInfo.UserEnrollId,
                                    sex: UserInfo.Gender
                                })
                                doublesObj[UserInfo.PairId] = arr;
                            }
                            for(var key in doublesObj){
                                doublesArr.push(doublesObj[key]);
                            }
                            this.doublesArr = doublesArr;
                        }
                    }else{
                        this.member.list =  GroupUserList;
                        if(!GroupUserList || GroupUserList.length == 0){
                            this.loadMore = "无数据";
                        }
                    }
                }
            })
            //可加入的参赛人员
            GetCanJoinGroupUserList({
                DeputationEnrollId: this.deputationEnrollId,
                GroupId: groupId
            }).then(data=>{
                if(data.Code == 0){
                    var UserList = data.UserList || [],
                        list = [];
                    //处理与查询分组的数据结构相同
                    UserList.forEach(item => {
                        list.push({
                            UserInfo: item
                        })
                    });
                    this.rests.list = list;
                }
            })
        },
        setRoleInfo(){
            if(this.categoryTebIndex == 1){
                let roles = this.roles,
                    hints = [];
                for(var i=0;i<roles.length;i++){
                    let obj = roles[i];
                    if(obj.PeopleMin){
                        if(obj.PeopleMin == 1 && obj.NowEnrollNum == 0){
                            hints.push('依据赛事规程，你需要添加'+obj.RoleName);
                        }else if(obj.PeopleMin > 1 &&  obj.NowEnrollNum < obj.PeopleMin){
                            hints.push('依据赛事规程，你需要添加'+obj.PeopleMin+'名'+obj.RoleName);
                        }
                    }
                }
                this.categoryInfo.hints = hints;
            }
        },
        setGroupInfo(groupId){
            let groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == groupId)[0];
            let {
                GroupSetting,
                EnrollNum,
                EnrollMaleNum,
                EnrollFemaleNum,
                EnrollDoublesNum
            } = groupObj;
            let { 
                LeagueGroupId,
                LeagueGroupName,
                AthletesMin,
                AthletesMax,
                MaleAthletesMin,
                MaleAthletesMax,
                FemaleAthletesMin,
                FemaleAthletesMax,
                GroupOrderNo 
            } = GroupSetting;
            let hints = [];
            if(GroupSetting.GroupType == 3){
                if(AthletesMin && EnrollDoublesNum < AthletesMin){
                    hints.push(`该组别至少${AthletesMin}对组合才可以参加比赛`);
                }
                if(AthletesMax && EnrollDoublesNum >= AthletesMax){
                    hints.push(`该组别每队限报${AthletesMax}对组合`);
                }
            }else{
                if(AthletesMin && EnrollNum < AthletesMin){
                    hints.push(`该组别至少${AthletesMin}名人员才可以参加比赛`);
                }else{
                    if(MaleAthletesMin && EnrollMaleNum < MaleAthletesMin){
                        hints.push(`该组别至少${MaleAthletesMin}名男子才可以参加比赛`);
                    }
                    if(FemaleAthletesMin && EnrollFemaleNum < FemaleAthletesMin){
                        hints.push(`该组别至少${FemaleAthletesMin}名女子才可以参加比赛`);
                    }
                }
                if(AthletesMax && EnrollNum >= AthletesMax){
                    hints.push(`该组别每队限报${AthletesMax}人`);
                }else{
                    if(MaleAthletesMax && EnrollMaleNum >= MaleAthletesMax){
                        hints.push(`该组别每队限报${MaleAthletesMax}名男子`);
                    }
                    if(FemaleAthletesMax && EnrollFemaleNum >= FemaleAthletesMax){
                        hints.push(`该组别每队限报${FemaleAthletesMax}名女子`);
                    }
                }
            }
            this.categoryInfo = {
                groupName: LeagueGroupName,
                num: GroupSetting.GroupType == 3 ? EnrollDoublesNum : EnrollNum,
                hints: hints
            };
            this.group.type = GroupSetting.GroupType;
            this.group.GenderLimit = GroupSetting.GenderLimit;
        },
        saveMemberInfo(){
            this.categoryInfo = {
                groupName: "",
                num: 0,
                hints:[]
            };
            this.$set(this.rests,'list',[]);
            this.getGroupList();
            this.getRoleList();
            if(this.categoryTebIndex == 2){
                this.getGroupUserList(this.group.Id);
            }else{
                this.getUserList(this.categoryTebIndex == 0 ? 0 : 2);
            }
        },
		//标记组合
		setDoublesUserInfo(userList, doublesArr){
			let list = [];
			userList.forEach((item) => {
				let className = "no-select",
					numText = "",
					num = 0;
				for(let i = 0;i < doublesArr.length;i++){
					let doubles = doublesArr[i];
					let isSelect = doubles.some(userItem => userItem.id === item.UserInfo.UserEnrollId);
					let isDouble = doubles.length == 2;
					if(isSelect){
						num = i + 1;
						let num2 = num % 7;
						className = "color-" + (num2 == 0 ? 7 : num2);
						if(isDouble){
							numText = "组合" + numberToChinese(num);
						}
						break;
					}
				}
				list.push({
					...item,
					doublesClassName: className,
					doublesNumText: numText,
					doublesNum: num
				})
			})
			return list;
		}
    }
}
</script>
<style lang="scss" scoped>
@import '@assets/scss/TeamPersonnel.scss';
.enroll_operation{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50%;
	transform: translateY(-50%);
}
.registered,
.pay{
    width: 670px;
    height: 122px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 59px;
    padding: 0 40px 0 50px;
    box-sizing: border-box;
    box-shadow: 0 10px 19px 0 #EBF2F5;
    position: relative;
    div{
        h4{
            font-size: 32px;
            color: #3A3F49;
            line-height: 38px;
            font-weight: 500;
        }
        p{
            font-size: 26px;
            color: #7E7E7F;
            line-height: 36px;
            font-weight: 400;
            margin-top: 8px;
        }
    }
    button{
        width: 148px;
        @include line-height(68px);
        background: #1B1C1E;
        border-radius: 54px;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center;
        font-weight: 500;
    }
    img{
        width: 280px;
        height: 284px;
        position: absolute;
        left: 31%;
        top: -114%;
    }
}
.pay{
    margin-top: 120px;
    div h4{
        color: #F34911;
    }
    img{
        width: 274px;
        height: 226px;
        left: 33%;
        top: -92%;
    }
}
.nav-title_pulldown{
    width: auto;
    height: 50px;
    font-size: 36px;
    color: #1B1C1E;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
		flex: none;
        width: 32px;
        height: 32px;
        margin-left: 4px;
        margin-top: 1px;
    }
}
.page-title_pulldown{
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	img{
		flex: none;
		width: 40px;
		height: 40px;
		margin-left: 12px;
		margin-top: 25px;
	}
}
.deputation{
	.deputation_list{
		width: 100%;
		height: 482px;
		overflow-y: auto;
		.deputation_item{
			width: 100%;
			height: 104px;
			padding: 0 40px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			span{
				font-weight: 400;
				font-size: 28px;
				color: #1B1C1E;
				line-height: 40px;
				text-align: center;
			}
			&.active span{
				font-weight: 500;
				color: #7AD21A;
			}
		}
	}
	.operation{
		width: 100%;
		height: auto;
		padding-top: 128px;
		padding-bottom: 40px;
		box-sizing: border-box;
		background: #FFFFFF;
		position: relative;
		>.button{
			width: 288px;
			height: 108px;
			display: block;
			background: #1B1C1E;
			border-radius: 54px;
			margin: 0 auto;

			font-size: 32px;
			color: #FFFFFF;
			font-weight: 500;
			line-height: 108px;
            text-align: center;
		}
		.deputation_operation{
			width: 100%;
			height: 72px;
			position: absolute;
			top: 16px;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			.button{
				width: 268px;
				height: 72px;
				border-radius: 36px;
				border: 2px solid #E9E9E9;
				margin-right: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				&:last-of-type{
					margin-right: 0;
				}
				img{
					width: 48px;
					height: 48px;
					margin-right: 4px;
					margin-left: -12px;
				}
				span{
					font-weight: 500;
					font-size: 28px;
					color: #404349;
					line-height: 40px;
				}
			}
		}
	}
}
</style>